<div class="white_paper_wrap">
    <div class="paper_top_sections">
        <h1>Uma Comparação de Trinka com Grammarly e LanguageTool em Texto Acadêmico</h1>
    </div>

    <div class="need_whitePaper_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="need_content_text">
                        <h2>Por que você precisa deste whitepaper?</h2>
                        <p>Várias damas gramaticais estão disponíveis para o inglês geral, mas raramente se concentra especificamente na escrita acadêmica de inglês, terminologia, convenções científicas e questões relacionadas à leitura da publicação.</p>

                        <p>Aprofundar a verificação emseu artigo irá equipá-lo para tomar a decisão mais informada ao avaliar e integrar um assistente de escrita, verificador de gramática e ferramenta corretora de idiomas para sua escrita pessoal, profissional, acadêmica ou técnica.</p>

                        <p>Este whitepaper lhe dará a compreensão precisa e a imagem apoiada por dados de como a Trinka se adequa melhor à escrita acadêmica, porque atinge um bom equilíbrio entre precisão e cobertura e seus recursos específicos exclusivos de leitura de publicação.</p>
                        <div class="download_whitePaper text-center">
                            <a id="downloadThisWhitePaper" href="../../../assets/resources/Trinka_WhitePaper.pdf" download="trinka-vs-grammarly-vs-language-tool">
                                <img src="../../../assets/images/whitePaper_download.png" alt="download">Faça o download deste whitepaper</a>
                        </div>
                        <div class="key_takewaye_sections">
                            <h2>Principais dicas</h2>
                            <div class="row">
                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>1</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>Pontos de atenção específicos de escritores, autores e escritores acadêmicos profissionais em todo o mundo.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>2</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>Trabalhabilidade e limitações dos assistentes de escrita atualmente disponíveis.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>3</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>Breve comparação entre Trinka vs. Grammarly vs. Ferramentas de Correção.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>4</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>A Trinka supera todos os outros assistentes de escrita.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="sneak_peek_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="sneak_heading">
                        <h2>Dê uma olhada neste whitepaper</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="whitePaper_slider testimonials">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="center">

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="comparison slide">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar slide">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="comparison slide">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar slide">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="comparison slide">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="comparison slide">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar slide">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="comparison slide">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar slide">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="comparison slide">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar slide">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="bottomSilderButtons">
        <div class="download_whitePaper text-center">
            <a id="downloadThisWhitePaperFooter" href="../../../assets/resources/Trinka_WhitePaper.pdf" download="trinka-vs-grammarly-vs-language-tool">
                <img src="../../../assets/images/whitePaper_download.png" alt="download">Faça o download deste whitepaper</a>
        </div>
    </div>
</div>